const paymentHistoryStatuses = {
  PENDING: 'PENDING',
  SUCCESS: 'SUCCESS'
};

export default paymentHistoryStatuses;
